const LABELS = {
  VALIDATION_MESSAGES: {
    INVALID_CNPJ: 'Dígito verificador do CNPJ inválido',
    INVALID_CNPJ_GENERIC: 'CNPJ inválido',
    CNPJ_INVALID_LENGTH: 'O CNPJ deve ser vazio ou ter 14 caracteres',
    REQUIRED: 'Obrigatório'
  },
  CNPJ: 'CNPJ',
  CNPJ_DATA_TEST_ID: 'cnpj'
};

export default LABELS;
